import {
  CreditCardOutlined,
  DisconnectOutlined,
  ExclamationCircleFilled,
  FileExclamationFilled,
  FileExclamationOutlined,
  LockOutlined,
  WarningFilled,
  DollarOutlined,
  DeleteColumnOutlined,
  DollarCircleFilled,
  ClockCircleFilled,
  CloseCircleFilled,
  CloseCircleOutlined,
  DashboardFilled,
  LockFilled,
} from '@ant-design/icons'
import { MaterialIcon } from '@gravitate-js/excalibrr'
import arbOppIcon from '@assets/CustomIcons/order_flags/arb_opp.svg'
import badSupplyErrorIcon from '@assets/CustomIcons/order_flags/bad_supply_error.svg'
import badSupplyWarningIcon from '@assets/CustomIcons/order_flags/bad_supply_warning.svg'
import CloseRunoutErrorIcon from '@assets/CustomIcons/order_flags/close_runout_error.svg'
import CloseRunoutWarningIcon from '@assets/CustomIcons/order_flags/close_runout_warning.svg'
import DependentIcon from '@assets/CustomIcons/order_flags/dependent.svg'
import PrimaryDependentIcon from '@assets/CustomIcons/order_flags/primary_dependent.svg'
import RecentDropInfoIcon from '@assets/CustomIcons/order_flags/recent_drop_info.svg'
import TankDisconnectErrorIcon from '@assets/CustomIcons/order_flags/tank_disconnect_error.svg'
import { IconTrendingDown } from '@tabler/icons-react'
import UnavailableSupplyIcon from '@assets/CustomIcons/order_flags/unavailable_supply.svg'
import UnsafeSplitWarningIcon from '@assets/CustomIcons/order_flags/unsafe_split_warning.svg'
import WindowErrorIcon from '@assets/CustomIcons/order_flags/window_error.svg'
import WindowWarningIcon from '@assets/CustomIcons/order_flags/window_warning.svg'
import {
  EmptyAlertIcon,
  RunoutWithinIcon,
} from '@components/StoreMonitoring/StoreDashboard/TankAlertDisplay/components/icons'

export function FlagIconSwitch({ flag, className, isOrderFlag, view }) {
  if (flag.type === 'recent_drop') {
    return <img src={RecentDropInfoIcon} className={className} />
  }
  if (flag.type === 'dispatch_window') {
    if (flag.severity === 'warning') {
      return <img src={WindowWarningIcon} className={className} />
    }
    if (flag.severity === 'error') {
      return <img src={WindowErrorIcon} className={className} />
    }
  } else if (flag.type === 'supply_option') {
    if (flag.severity === 'error') {
      return <img src={UnavailableSupplyIcon} className={className} />
    }
    if (flag.severity === 'warning') {
      return <img src={UnavailableSupplyIcon} className={className} />
    }
  } else if (flag.type === 'dependent') {
    if (flag.severity === 'info') {
      return <img src={DependentIcon} className={className} />
    }
    if (flag.severity === 'money') {
      return <img src={PrimaryDependentIcon} className={className} />
    }
  } else if (flag.type === 'run_out') {
    return <RunoutWithinIcon size='small' threshold={flag.threshold} severity={flag.severity} />
  } else if (flag.type === 'tank_reading') {
    if (flag.severity === 'warning') {
      return <img src={TankDisconnectWarningIcon} className={className} />
    }
    if (flag.severity === 'error') {
      return <img src={TankDisconnectErrorIcon} className={className} />
    }
  } else if (flag.type === 'optimal_supply' && flag.severity === 'warning') {
    return <img src={badSupplyWarningIcon} className={className} />
  } else if (flag.type === 'optimal_supply' && flag.severity === 'money') {
    return <img src={arbOppIcon} className={className} />
  } else if (flag.type === 'optimal_supply' && flag.severity === 'error') {
    return <img src={badSupplyErrorIcon} className={className} />
  } else if (flag.type === 'unsafe_split') {
    return <img src={UnsafeSplitWarningIcon} className={className} />
  } else if (isOrderFlag) return <LockOutlined />
  else if (flag.type === 'credit_hold') {
    return <LockFilled style={{ fontSize: '0.8em' }} />
  } else if (flag.type === 'compliance_hold' && view === 'tripGridCell') {
    return <FileExclamationFilled style={{ color: 'var(--theme-error' }} />
  } else if (flag.type === 'compliance_hold') {
    return <FileExclamationOutlined style={{ color: 'var(--theme-error' }} />
  } else if (flag.severity === 'error') {
    return <ExclamationCircleFilled style={{ color: 'var(--theme-error' }} />
  } else if (flag.severity === 'warning') {
    return <WarningFilled style={{ color: 'var(--theme-warning', fontSize: '1.5em' }} />
  } else {
    return null
  }
}

// #OUTDATED keeping old for now, but new flag icons here:
export function FlagIconSwitch2({ flag, isOrderFlag, view }) {
  if (flag.type === 'run_out' && flag.severity === 'empty') {
    return <EmptyAlertIcon size='small' />
  }
  if (flag.type === 'recent_drop') {
    return <MaterialIcon style={{ color: 'var(--theme-color-2' }} icon='history' />
  }
  if (flag.type === 'dispatch_window') {
    if (flag.severity === 'warning' || flag.status === 'warning') {
      return <MaterialIcon icon='partner_reports' />
    }
    if (flag.severity === 'error' || flag.status === 'error') {
      return <MaterialIcon icon='partner_reports' fill />
    }
  } else if (flag.type === 'supply_option') {
    return <DisconnectOutlined />
  } else if (flag.type === 'dependent') {
    if (flag.severity === 'info') {
      return <img src={DependentIcon} />
    }
    if (flag.severity === 'money') {
      return <img src={PrimaryDependentIcon} />
    }
  } else if (flag.type === 'run_out') {
    if (flag.severity === 'warning' || flag.status === 'warning') {
      return <CloseCircleOutlined />
    }
    if (flag.severity === 'error' || flag.status === 'error') {
      return <CloseCircleFilled />
    }
  } else if (flag.type === 'retain') {
    if (flag.severity === 'warning' || flag.status === 'warning') {
      return <DashboardFilled />
    }
    if (flag.severity === 'error' || flag.status === 'error') {
      return <DashboardFilled />
    }
  } else if (flag.type === 'tank_reading') {
    if (flag.severity === 'warning' || flag.status === 'warning') {
      return <MaterialIcon icon='sensors_off' />
    }
    if (flag.severity === 'error' || flag.status === 'error') {
      return <MaterialIcon icon='sensors_off' fill />
    }
  } else if (flag.type === 'optimal_supply') {
    if (flag.severity === 'warning' || flag.status === 'warning') {
      return <DollarCircleFilled />
    }
    if (flag.severity === 'error' || flag.status === 'error') {
      return <DollarOutlined />
    }
    if (flag.severity === 'money' || flag.status === 'money') {
      return <DollarOutlined />
    }
  } else if (flag.type === 'unsafe_split') {
    return <MaterialIcon icon='warning' fill />
  } else if (flag.type === 'unset') {
    return <MaterialIcon icon='help' />
  } else if (flag.type === 'price_flag') {
    return <MaterialIcon icon='price_change' fill />
  } else if (flag.type === 'product incompatibility') {
    return <MaterialIcon icon='water_damage' />
  } else if (flag.type === 'compartment product incompatibility') {
    return <MaterialIcon icon='water_damage' fill />
  } else if (flag.type === 'product mismatch') {
    return <ExclamationCircleFilled />
  } else if (flag.type === 'volume_discrepancy') {
    return <WarningFilled />
  } else if (flag.type === 'card_alert') {
    return <MaterialIcon icon='credit_card_off' fill />
  } else if (flag.type === 'unavailable') {
    return <DeleteColumnOutlined />
  } else if (flag.severity === 'success' || flag.status === 'success') {
    return <ClockCircleFilled />
  } else if (isOrderFlag) {
    return <LockOutlined style={{ fontSize: '0.8em' }} />
  } else if (flag.type === 'credit_hold') {
    return <LockFilled style={{ fontSize: '0.8em' }} />
  } else if (flag.type === 'compliance_hold' && view === 'tripGridCell') {
    return <FileExclamationFilled style={{ fontSize: '0.8em' }} />
  } else if (flag.type === 'compliance_hold') {
    return <FileExclamationOutlined style={{ fontSize: '0.8em' }} />
  } else if (flag.type === 'sales_variance') {
    return <IconTrendingDown />
  } else if (flag.severity === 'error' || flag.status === 'error') {
    return <ExclamationCircleFilled style={{ fontSize: '0.8em' }} />
  } else if (flag.severity === 'warning' || flag.status === 'warning') {
    return <WarningFilled style={{ fontSize: '0.8em' }} />
  } else {
    return null
  }
}
